"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagCount = void 0;
var vue_1 = require("vue");
var Tag_1 = require("./Tag");
exports.TagCount = vue_1.default.component('tag-count', {
    props: {
        tag: {
            type: String,
        },
        count: {
            type: Number,
        },
        size: {
            type: String,
        },
        type: {
            type: String,
        },
        hideCount: {
            required: false,
            type: Boolean,
        },
    },
    components: {
        'tag': Tag_1.Tag,
    },
    methods: {
        getClasses: function () {
            var classes = ['tag-display'];
            if (this.count === 0 && this.tag !== 'vp' && this.tag !== 'escape') {
                classes.push('tag-no-show');
            }
            return classes.join(' ');
        },
        getCountClasses: function () {
            var classes = ['tag-count-display'];
            if (this.count === 0 && this.tag !== 'vp' && this.tag !== 'escape') {
                classes.push('tag-count-no-show');
            }
            return classes.join(' ');
        },
        getCount: function () {
            return this.hideCount === true ? '?' : this.count;
        },
    },
    template: "<div :class=\"getClasses()\">\n        <tag :tag=\"tag\" :size=\"size\" :type=\"type\"/>\n        <span :class=\"getCountClasses()\">{{ getCount() }}</span>\n    </div>",
});
//# sourceMappingURL=TagCount.js.map